import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { LogIn, LogOut, Users, Package, ArrowRight } from 'lucide-react';

import { KpiCard } from '@/components/dashboard/KpiCard';
import { TendenciaChart } from '@/components/accesos/TendenciaChart';
import { DentroAhoraPanel } from '@/components/accesos/DentroAhoraPanel';
import { getMetricasAccesos, getDentro, getTendencia } from '@/services/api/accesos.api';

/**
 * Resumen de accesos para el Dashboard. Hace sus propias consultas: solo se
 * monta para roles con permiso (ADMIN/SOPORTE), por lo que no necesita gating
 * interno — el padre decide si renderizarlo.
 */
export function AccesosResumen() {
  const { data: metricas, isLoading: loadingMetricas } = useQuery({
    queryKey: ['accesos-metricas'],
    queryFn: getMetricasAccesos,
    refetchInterval: 60_000,
  });

  const { data: dentro, isLoading: loadingDentro } = useQuery({
    queryKey: ['accesos-dentro'],
    queryFn: getDentro,
    refetchInterval: 60_000,
  });

  const { data: tendencia, isLoading: loadingTendencia } = useQuery({
    queryKey: ['accesos-tendencia'],
    queryFn: () => getTendencia(7),
    refetchInterval: 60_000,
  });

  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-base font-semibold text-foreground">Accesos de hoy</h3>
          <p className="text-sm text-muted-foreground">Movimientos registrados desde portería</p>
        </div>
        <Link to="/accesos" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700">
          Ver módulo
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KpiCard label="Ingresos hoy" value={metricas?.ingresos_hoy ?? 0} icon={LogIn} tone="success" loading={loadingMetricas} />
        <KpiCard label="Salidas hoy" value={metricas?.salidas_hoy ?? 0} icon={LogOut} tone="warning" loading={loadingMetricas} />
        <KpiCard label="Dentro ahora" value={metricas?.dentro_ahora ?? 0} icon={Users} tone="primary" loading={loadingMetricas} />
        <KpiCard label="Foráneos activos" value={metricas?.foraneos_activos ?? 0} icon={Package} tone="neutral" loading={loadingMetricas} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2">
          <TendenciaChart data={tendencia ?? []} loading={loadingTendencia} />
        </div>
        <DentroAhoraPanel data={dentro ?? []} loading={loadingDentro} />
      </div>
    </section>
  );
}
